export const state = () => ({
  studentParents: [],
  loading: false,
  error: null,
  pagination: {
    page: 0,
    size: 10,
    totalElements: 0,
    totalPages: 0
  }
})

export const getters = {
  studentParents: (state) => state.studentParents,
  loading: (state) => state.loading,
  error: (state) => state.error,
  pagination: (state) => state.pagination
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_STUDENT_PARENTS(state, data) {
    if (data.content) {
      state.studentParents = data.content
      state.pagination = {
        page: data.number,
        size: data.size,
        totalElements: data.totalElements,
        totalPages: data.totalPages
      }
    } else {
      state.studentParents = Array.isArray(data) ? data : []
    }
  },
  ADD_STUDENT_PARENT(state, studentParent) {
    state.studentParents.push(studentParent)
  },
  REMOVE_STUDENT_PARENT(state, { studentId, parentId }) {
    state.studentParents = state.studentParents.filter(
      sp => !(sp.student?.id === studentId && sp.parent?.id === parentId)
    )
  }
}

export const actions = {
  async fetchByStudent({ commit }, { studentId, page = 0, size = 10, sortBy = 'parentId', direction = 'asc' } = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.get(`/auth/api/student-parents/by-student/${studentId}`, {
        params: { page, size, sortBy, direction }
      })
      commit('SET_STUDENT_PARENTS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch student parents')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchByParent({ commit }, { parentId, page = 0, size = 10, sortBy = 'studentId', direction = 'asc' } = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.get(`/auth/api/student-parents/by-parent/${parentId}`, {
        params: { page, size, sortBy, direction }
      })
      commit('SET_STUDENT_PARENTS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch parent students')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async linkStudentParent({ commit }, studentParentData) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.post('/auth/api/student-parents', studentParentData)
      commit('ADD_STUDENT_PARENT', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to link student and parent')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async unlinkStudentParent({ commit }, { studentId, parentId }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      await this.$axios.delete('/auth/api/student-parents', {
        data: { studentId, parentId }
      })
      commit('REMOVE_STUDENT_PARENT', { studentId, parentId })
      return true
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to unlink student and parent')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

